<template>
	<div style="height: 84vh;">
		<div class="tenant_search">
			<div class="tenant_search_1">
				<i></i>
				<el-date-picker style="width: 100%;" v-model="data.start_time" type="date" placeholder="日期起"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
				<div style="width: 1rem;"></div>
				<el-date-picker style="width: 100%;" v-model="data.end_time" type="date" placeholder="日期止"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<button class="search_button" @click="search()">搜索</button>
			<button class="search_button" @click="search('重置')">重置</button>
		</div>
		<div style="display: flex;justify-content: flex-end;margin-right: 1rem;">数据总共：{{total}}条</div>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total"
			@Currentchange="contractlistcontractlist" style="margin: 1rem;"></MyTable>
	</div>
</template>

<script>
	import MyTable from "@/components/MyTable/index.vue"
	import {
		energy_look,
		energy_delete,
		water_look
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'devicelist',
				tableData: [],
				table_label: [{
					label: 'ID',
					value: 'id'
				}, {
					label: '房间号',
					value: 'room_num'
				}, {
					label: '剩余',
					value: 'residue'
				}, {
					label: '累计',
					value: 'total'
				}, {
					label: '日期',
					value: 'create_time'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 10,
					eid: ""
				}
			}
		},
		props: [
			"item",
			"name"
		],
		methods: {
			search(resetting) {
				if (resetting != undefined) {
					this.data.room_num = ''
					this.data.end_time = ''
					this.data.start_time = ''
					this.contractlistcontractlist()
				} else {
					if (this.name == 'Metermanagement') {
						energy_look(this.data).then(res => {
							console.log('res', res);
							if (res.status == 200) {
								this.tableData = res.data.list
								this.total = res.data.count
							}
						})
					} else {
						water_look(this.data).then(res => {
							console.log('res', res);
							if (res.status == 200) {
								this.tableData = res.data.list
								this.total = res.data.count
							}
						})
					}

				}
			},
			contractlistcontractlist(value) {

				this.data.page = value ? value : 1
				if (this.name == 'Metermanagement') {
					this.data.eid = JSON.parse(JSON.stringify(this.item.id));
					energy_look(this.data).then(res => {
						console.log('res', res);
						if (res.status == 200) {
							this.tableData = res.data.list
							this.total = res.data.count
						}
					})
				} else {
					this.data.wid = JSON.parse(JSON.stringify(this.item.id));
					water_look(this.data).then(res => {
						console.log('res', res);
						if (res.status == 200) {
							this.tableData = res.data.list
							this.total = res.data.count
						}
					})
				}
			},
			changedia(value) {
				this.centerDialogVisible = value
			}
		},
		components: {
			MyTable,
		},
		created() {
			this.contractlistcontractlist()
		},
		watch: {
			item: function(newVal, oldVal) {
				this.contractlistcontractlist()
			}
		}
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: #fff;
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 4.8rem;
	}


	.tenant_search_1 .el-input {
		width: 10rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}
</style>